module.exports = __webpack_public_path__ + "img/sortImg1-1-5.c6fd1d40.png";